import { connect } from "react-redux";
import get from "lodash/get";

import {
  geocoderSearch as onGeocoderSearch,
  selectGeocoderSearch as onSelectGeocoderSearch,
  unselectGeocoderSearch as onUnselectGeocoderSearch,
  clearGeocoderSearch as onClearGeocoderSearch,
  setGeocoderSearchData as onSetGeocoderSearchData,
} from "../../actions/geocoderActions";

const mapStateToProps = (state) => ({
  searchDataState: state.geocoder.searchDataState,
  dataSearch: get(state, ["geocoder", "dataSearch"], null),
  geocoderSearchResult: get(state, ["geocoder", "geocoderSearchResult"], []),
  selectedGeocoderSearch: get(state, ["geocoder", "selectedGeocoderSearch"], null),
});

const mapDispatchToProps = {
  onGeocoderSearch,
  onSelectGeocoderSearch,
  onUnselectGeocoderSearch,
  onClearGeocoderSearch,
  onSetGeocoderSearchData,
};

const withGeocoder = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withGeocoder };
